export type BoxIndexRule = {
  operator: 'field-equals',
  checkField: string,
  checkValue: string | number,
  value: unknown,
} | {
  operator: 'box-index-expression',
  checkField: string, // make this an array if you need to quickly allow this to use multiple variables without a refactor
  expression: string,
  valueExpression: string,
} | {
  operator: 'default',
  value: unknown,
};

const parseBoxIndexRules = (rules: string | null): Array<BoxIndexRule> => {
  try {
    const ruleArray = JSON.parse(rules || '[]') as Array<BoxIndexRule>;
    if (ruleArray.length > 0) {
      ruleArray.push({operator: 'default', value: null});
    }
    return ruleArray;
  } catch {
    console.warn('invalid json format:');
    console.log(rules); // eslint-disable-line no-console
    return [];
  }
};

export default parseBoxIndexRules;